<badge-list [label]="'share.selected-user'|translate" [items]="badgeItems" (remove)="removeUser($event)"></badge-list>
